import React, { Component } from 'react';
import {AUDIO_FILES} from "../constants";

class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchQuery: '',

        };
    }

    // Обработчик изменения текста в инпуте
    handleSearchChange = (event) => {
        this.setState({ searchQuery: event.target.value });
    };

    render() {
        const { searchQuery } = this.state;
        // Данные берутся напрямую из props
        const { items } = this.props;

        const filteredItems = items.filter(item =>
            item.name.toLowerCase().includes(searchQuery.toLowerCase())
        );

        return (
            <div>
                <input
                    type="text"
                    placeholder="Поиск по имени..."
                    value={searchQuery}
                    onChange={this.handleSearchChange}
                />
            </div>
        );
    }
}

export default Search;